import Model, { attr, belongsTo } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class AirbnbOfficialResolutionModel extends Model {
  @attr('string') status!: string;
  @attr('string') initiator!: string;
  @attr('string') responder!: string | null;
  @attr('string') confirmationCode!: string;
  @attr('string') amountPaid!: string;
  @attr('string') amountRequested!: string | null;
  @attr('boolean') customerSupportInitiated!: boolean;
  @attr('date') endDate!: Date;
  @attr('string') notes!: string;
  @attr('string') reason!: string;
  @attr('date') startDate!: Date;

  @cached
  get listingName(): string {
    return this.booking?.displayName || '';
  }

  @cached
  get bookingId(): string {
    return this.booking?.id || '';
  }

  @belongsTo('channel-notification', {
    inverse: 'airbnbOfficialResolutions',
    async: false,
  })
  channelNotification!: ModelRegistry['channel-notification'];

  @belongsTo('airbnb-official-connection', { inverse: null, async: false })
  airbnbOfficialConnection!: ModelRegistry['airbnb-official-connection'];

  @belongsTo('booking', { inverse: null, async: false })
  booking?: ModelRegistry['booking'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'airbnb-official-resolution': AirbnbOfficialResolutionModel;
  }
}
